import { mapToCanActivate, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ROUTE_PATH } from './constants/route-path';
import { AuthGuard } from './_helper/auth.guard';
import { MobileLayoutComponent } from './layouts/mobile-layout/mobile-layout.component';
import { DefaultRedirectGuard } from './_helper/default-redirect.gaurd';
import { UnsavedChangesGuard } from './_helper/unsaved-changes.guard';
import { MapGuard } from './_helper/map.guard';
import { MobileDefaultRedirectGuard } from './_helper/mobile-default-redirect.gaurd';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    // canActivateChild: mapToCanActivate([AuthGuard]),
    children:
      [
        {
          path: '',
          canActivate: mapToCanActivate([DefaultRedirectGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}`,
          canActivate: mapToCanActivate([DefaultRedirectGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}/:id`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}/:id/:floorid`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: ROUTE_PATH.TAG,
          children: [
            {
              path: ROUTE_PATH.USERTAG,
              loadComponent: () => import('./modules/tag/dai-tag/dai-tag.component').then(m => m.DaiTagComponent)
            },
            {
              path: ROUTE_PATH.STAFFTAG,
              loadComponent: () => import('./modules/tag/staff-tag/staff-tag.component').then(m => m.StaffTagComponent)
            },
            {
              path: ROUTE_PATH.BATTERYTAG,
              loadComponent: () => import('./modules/tag/battery-tag/battery-tag.component').then(m => m.BatteryTagComponent)
            }
          ]
        },
        {
          path: ROUTE_PATH.ANALYSIS,
          children: [
            {
              path: ROUTE_PATH.HISTORY,
              loadComponent: () => import('./modules/analysis/history/history.component').then(m => m.HistoryComponent)
            },
            {
              path: ROUTE_PATH.HEATMAP,
              loadComponent: () => import('./modules/analysis/heatmap/heatmap.component').then(m => m.HeatMapComponent)
            },
            {
              path: ROUTE_PATH.INTERACT,
              loadComponent: () => import('./modules/analysis/interact/interact.component').then(m => m.InteractComponent)
            },
            {
              path: '', // default child
              redirectTo: ROUTE_PATH.HISTORY,
              pathMatch: 'full'
            }
          ]
        },
        {
          path: ROUTE_PATH.SETTINGS,
          children: [
            {
              path: ROUTE_PATH.TAGREGISTRATION,
              loadComponent: () => import('./modules/settings/tag-registration/tag-registration.component').then(m => m.TagRegistrationComponent),
              canDeactivate: [UnsavedChangesGuard]

            },
            {
              path: '', // default child
              redirectTo: ROUTE_PATH.TAGREGISTRATION,
              pathMatch: 'full',
              canDeactivate: [UnsavedChangesGuard]
            },
            {
              path: ROUTE_PATH.ZONESETTING,
              loadComponent: () => import('./modules/settings/zone-setting/zone-setting.component').then(m => m.ZoneSettingComponent),
                canDeactivate: [UnsavedChangesGuard]
            },
            {
              path: ROUTE_PATH.DAIREGISTRATION,
              loadComponent: () => import('./modules/settings/dai-registration/dai-registration.component').then(m => m.DaiRegistrationComponent),
              canDeactivate: [UnsavedChangesGuard]
            },
            {
              path: ROUTE_PATH.STAFFREGISTRATION,
              loadComponent: () => import('./modules/settings/staff-registration/staff-registration.component').then(m => m.StaffRegistrationComponent),
              canDeactivate: [UnsavedChangesGuard]
            },
            {
              path: ROUTE_PATH.ACCOUNT_MANAGEMENT,
              loadComponent: () => import('./modules/settings/account-management/account-management.component').then(m => m.AccountManagementComponent)
            },
            {
              path: ROUTE_PATH.AUTO_RECORDING,
              loadComponent: () => import('./modules/settings/auto-recording-setting/auto-recording-setting.component').then(m => m.AutoRecordingSettingComponent),
              canDeactivate: [UnsavedChangesGuard]
            },
            {
              path: ROUTE_PATH.SCREEN_SETTING,
              loadComponent: () => import('./modules/settings/screen-setting/screen-setting.component').then(m => m.ScreenSettingComponent),
            }
          ]
        }

      ]
  },
  {
    path: ROUTE_PATH.WEB_VIEW,
    component: MobileLayoutComponent,
    children:
      [
        {
          path: '',
          redirectTo: ROUTE_PATH.LOGIN,
          pathMatch: 'full',
        },
        {
          path: ROUTE_PATH.LOGIN,
          loadComponent: () => import('./modules/webview/login/webview-login.component').then(m => m.WebViewLoginComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}`,
          canActivate: mapToCanActivate([MobileDefaultRedirectGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}/:id`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.MAP}/:id/:floorid`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          // The call screen is the same map under its own path, so the native app can open it
          // with /webview/login?...&redirect=call
          path: `${ROUTE_PATH.CALL}`,
          canActivate: mapToCanActivate([MobileDefaultRedirectGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.CALL}/:id`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          path: `${ROUTE_PATH.CALL}/:id/:floorid`,
          canActivate: mapToCanActivate([MapGuard]),
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
             {
          path: ROUTE_PATH.MAP,
          loadComponent: () => import('./modules/map/map.component').then(m => m.MapComponent)
        },
        {
          // The analysis screens inside the mobile layout, so the native app can open them
          // with /webview/login?...&redirect=analysis/history
          path: ROUTE_PATH.ANALYSIS,
          children: [
            {
              path: ROUTE_PATH.HISTORY,
              loadComponent: () => import('./modules/analysis/history/history.component').then(m => m.HistoryComponent)
            },
            {
              path: ROUTE_PATH.HEATMAP,
              loadComponent: () => import('./modules/analysis/heatmap/heatmap.component').then(m => m.HeatMapComponent)
            },
            {
              path: ROUTE_PATH.INTERACT,
              loadComponent: () => import('./modules/analysis/interact/interact.component').then(m => m.InteractComponent)
            },
          ]
        },
      ]
  },
  {
    path: ROUTE_PATH.LOGIN,
    loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: ROUTE_PATH.CHOOSE_ORG,
    loadComponent: () => import('./modules/login/org-selection/org-selection.component').then(m => m.OrgSelectionComponent)
  },
  {
    path: ROUTE_PATH.CHOOSE_OFFICE,
    loadComponent: () => import('./modules/login/office-selection/office-selection.component').then(m => m.OfficeSelectionComponent)
  },
  {
    path: ROUTE_PATH.LIB,
    loadComponent: () => import('./modules/lib/lib.component').then(m => m.LibComponent)
  },
  {
    path: ROUTE_PATH.LOCKED,
    loadComponent: () => import('./modules/login/locked/locked.component').then(m => m.LockedComponent)
  },
  {
    path: ROUTE_PATH.PAGE_NOT_FOUND,
    loadComponent: () => import('./modules/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: `${ROUTE_PATH.PUBLIC_MAP}/:id`,
    loadComponent: () => import('./modules/public-map/public-map.component').then(m => m.PublicMapComponent)
  },
  {
    path: ROUTE_PATH.NO_MAP,
    loadComponent: () => import('./modules/login/no-map/no-map.component').then(m => m.NoMapComponent)
  },
];
